const galleryId = 51;

const items = [];

let id = galleryId * 1000;

function addItemToGroup(item, tag) {
    id++;
    items.push({
        "id": id,
        "title": { "en": "" },
        "src": item,
        "tags": [tag],
        "groups": [galleryId],
        "ordering": id,
    });
}

let group = [];

group = ["sh_1691417698.jpg","sh_1426462460.jpg","sh_1781845781.jpg","sh_1714380904.jpg"];
group.forEach((i) => addItemToGroup(i, '1. Procedure'));

group = ["sh_1845570109.jpg","sh_1516469219.jpg","sh_1646433997.jpg","sh_1713798562.jpg"];
group.forEach((i) => addItemToGroup(i, '2. Veneer'));

group = ["sh_1429358063.jpg","sh_1715694676.jpg","sh_747606946.jpg","sh_1536286949.jpg","sh_1219949056.jpg","sh_1591906099.jpg","sh_1253379829.jpg","sh_1313628839.jpg","sh_1715740828.jpg","sh_1716899455.jpg","sh_1720271191.jpg","sh_1720712938.jpg","sh_1720712944.jpg","sh_1808121076.jpg","sh_1828350683.jpg","sh_1509678233.jpg","sh_1828647050.jpg"];
group.forEach((i) => addItemToGroup(i, 'Before-after'));

group = [];
group.forEach((i) => addItemToGroup(i, 'deleted'));

export default items;
